import { h } from 'preact';
import { Navigation, ButtonSizes } from '../../../typing/enums';
import { MultiZoomButtonsWrap, MultiZoomButton } from './MultiZoomButtons.styled';

const MultiZoomButtons = props => (
  <MultiZoomButtonsWrap>
    <MultiZoomButton
      {...props}
      direction="left"
      size={ButtonSizes.MD}
      navigation={Navigation.ALWAYS}
      icon="zoomOut"
      disabled={props.currentStep === 0}
      onClick={props.zoomOut}
    />
    <MultiZoomButton
      {...props}
      direction="right"
      size={ButtonSizes.MD}
      navigation={Navigation.ALWAYS}
      icon="zoomIn"
      disabled={props.currentStep >= props.steps}
      onClick={props.zoomIn}
    />
  </MultiZoomButtonsWrap>
);

export default MultiZoomButtons;
